export type Theme = "light" | "dark";

export const themeStorageKey = "pentaadmin.theme";

function applyFavicon(theme: Theme) {
  const favicon = document.getElementById(
    "app-favicon",
  ) as HTMLLinkElement | null;
  if (favicon)
    favicon.href = `${process.env.PUBLIC_URL}/favicon-${
      theme === "dark" ? "white" : "blue"
    }-safe.png?v=2`;
}

export function getTheme(): Theme {
  try {
    return localStorage.getItem(themeStorageKey) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function setTheme(theme: Theme) {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  applyFavicon(theme);
  try {
    localStorage.setItem(themeStorageKey, theme);
  } catch {
    // The selected theme still applies when browser storage is unavailable.
  }
}

export function applyStoredTheme() {
  const theme = getTheme();
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  applyFavicon(theme);
}
